//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const negativePointsStyles = makeStyles((theme) => ({
  headerText: {
    textAlign: "left",
    font: "normal normal normal 1.5vw Sesgoe-ui",
    marginBottom: 0,
    letterSpacing: "0px",
    color: " #707070",
    fontSize: 28,
    display: "block",
    textAlign: "center",
  },
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
      padding: 10,
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  filterBtnGrid: {
    "@media (min-width: 600px)": {
      textAlign: "right",
    },
    "@media (max-width: 600px)": {
      padding: 10,
    },
  },
  filterBtn: {
    marginLeft: 20,
    marginTop: 5,
  },
  filterCardDiv: {
    overflowX: "auto",
  },
  filterCard: {
    boxShadow: " 10px 10px 10px #00000029 !important",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    width: "100%",
    zIndex: 100,
    marginTop: "2%",
  },
  filterCardGridContainer: {
    padding: 15,
    height: "100%",
  }, 
     cancelBtn: {
    padding: "6px 12px",
    backgroundColor: "#ededed",
    border: "none",
    borderRadius: 5,
    color: "#000",
    width: 90,
    cursor: "pointer",
},
  filterCardGrid: {
    borderRight: "1px solid #707070",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "@media (max-width: 600px)": {
      border: "none",
    },
  },
  filterCardHeadText: {
    fontWeight: "bold",
    fontSize: "1rem",
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
    width: "100%",
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#2F7CBD",
    backgroundColor: "#fff",
    fontSize: "0.875rem",
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 90,
    height: 40,
    textTransform: "capitalize",
    marginTop: "7%",
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#2F7CBD",
    fontSize: "0.875rem",
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 90,
    height: 40,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#2F7CBD",
    },
  },
  tableDiv: {
    marginTop: 20,
    marginBottom: 100,
    // height: 200
    // textAlign: 'justify',
    // wordBreak: 'break-word'
  },
  emptyDataText: {
    textAlign: "center",
    fontSize: 30,
    fontFamily: "segoe-ui",
    padding: "10%",
    opacity: "0.4",
  },
  badges: {
    position: "inherit",
    "@media (max-width: 600px)": {
      marginRight: 15,
    },
  },
  exportBtn: {
    backgroundColor: "#0a72ba",
    color: "#fff!important",
    fontSize: "0.875rem",
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: 10,
    width: 100,
    height: 40,
    border: "none",
    "&:hover": {
      backgroundColor: "#0a72ba",
    },
  },
  CSVlink: {
    display: "none",
  },
  sendEmailBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    marginBottom: 20,
    cursor: "pointer",
    padding: "4px 8px",
    marginRight: 10,
    "&:hover": {
        backgroundColor: "#0a72ba",
    }
},
sendEmailBtnDisable: {
  border: "none",
  backgroundColor: "#ededed",
  color: "#000",
  borderRadius: "5px",
  marginTop: 5,
  marginBottom: 20,
  cursor: "not-allowed",
  padding: "4px 8px",
  marginRight: 10,
  // "&:hover": {
  //     backgroundColor: "#0a72ba",
  // }
},
sendBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    cursor: "pointer",
    padding: "6px 12px",
    marginLeft: 10,
    width: 90,
    "&:hover": {
        backgroundColor: "#0a72ba",
    }
},
  orgNameColumn: {
    width: 100,
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
  grid: {
  
    marginBottom: 30
  },
  emailPopTextField: {
    width: "300px",
    marginBottom: 20,
    "@media (max-width: 600px)": {
        width: 300
    },
    "@media (max-width: 400px)": {
        width: 250
    }
}
}));

export const mpcDetailStyles = makeStyles((theme) => ({
  headGrid: {
    color: "#fff",
    fontSize: 25,
    display: "flex",
    alignSelf: "center",
    padding: 8,
  },
  headGridIcon: {
    fontSize: 35,
    alignSelf: "center",
    cursor: "pointer",
  },
  parentText: {
    fontSize: 25,
  },
  cancelBtn: {
    padding: "6px 12px",
    backgroundColor: "#ededed",
    border: "none",
    borderRadius: 5,
    color: "#000",
    width: 90,
    cursor: "pointer",
},
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
emailNoteText: {
  textAlign:"center"

},
  gridContainer: {
    marginTop: "2%",
  },
  emailPopTextField: {
    width: "300px",
    marginBottom: 20,
    "@media (max-width: 600px)": {
        width: 300
    },
    "@media (max-width: 400px)": {
        width: 250
    }
},
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
  },
  sendBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    cursor: "pointer",
    padding: "6px 12px",
    marginLeft: 10,
    width: 90,
    "&:hover": {
        backgroundColor: "#0a72ba",
    }
},
  editBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    // width: "43%",
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  editCancelBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    fontSize: 15,
    border: " 1px solid #305698",
    borderRadius: 10,
    width: 100,
    textTransform: "capitalize",
    margin: "5px 0",
  },

  firstDiv: {
    width: "100%",
    height: 40,
    backgroundColor: "#E4E4E4",
    marginTop: 10,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sendEmailBtnDisable: {
    border: "none",
    backgroundColor: "#ededed",
    color: "#000 !important",
    borderRadius: "5px",
    marginTop: 5,
    marginBottom: 20,
    cursor: "not-allowed",
    padding: "4px 8px",
    marginRight: 10,
    // "&:hover": {
    //     backgroundColor: "#0a72ba",
    // }
  },
  sendEmailBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    marginBottom: 20,
    cursor: "pointer",
    padding: "4px 8px",
    marginRight: 10,
    "&:hover": {
        backgroundColor: "#0a72ba",
    }
},
  secondDiv: {
    color: "#707070",
    fontSize: 22,
    fontWeight: "bold",
    marginLeft: 10,
    "@media (max-width: 768px)": {
      fontSize: 20,
    },
  },
  grid: {
    padding: 10,
    fontSize: 16,
    alignSelf: "center",
      
    marginBottom: 30
  },
  gridSpan: {
    fontWeight: "bold",
  },
  gridBtn: {
    marginTop: 10,
    marginBottom:15,
  },
  activeSpan: {
    color: "green",
  },
  inActiveSpan: {
    color: "red",
  },
  cssTextField: {
    width: 200,
    "@media (max-width: 500px)": {
      width: 150,
    },
    "@media (max-width: 400px)": {
      width: 100,
    },
  },
  // firstDiv: {
  //   backgroundColor :'#0a72ba'
  // }
}));

export const editMpcStyles = makeStyles((theme) => ({
  saveBtnGrid: {
    textAlign: "center",
  },
}));
